import CompanyAPI from 'dashboard/api/companies';
import { createStore } from 'dashboard/store/aifocus/storeFactory';
import camelcaseKeys from 'camelcase-keys';

export default createStore({
  name: 'Company',
  API: CompanyAPI,
  getters: {
    getCompaniesList: state => {
      return camelcaseKeys(state.records, { deep: true });
    },
    getCompanyById: state => id => {
      const company = state.records.find(c => c.id === id);
      return company ? camelcaseKeys(company, { deep: true }) : null;
    },
    getIndustries: state => {
      return state.industries || [];
    },
    getCompanyDeals: state => id => {
      return state.companyDeals[id] || { deals: [], meta: {}, summary: {} };
    },
    getCompanyContacts: state => id => {
      return state.companyContacts[id] || { contacts: [], meta: {} };
    },
  },
  state: {
    industries: [],
    companyDeals: {},
    companyContacts: {},
  },
  mutations: {
    SET_INDUSTRIES: (state, industries) => {
      state.industries = industries;
    },
    SET_COMPANY_DEALS: (state, { companyId, data }) => {
      state.companyDeals = {
        ...state.companyDeals,
        [companyId]: data,
      };
    },
    SET_COMPANY_CONTACTS: (state, { companyId, data }) => {
      state.companyContacts = {
        ...state.companyContacts,
        [companyId]: data,
      };
    },
  },
  actions: mutationTypes => ({
    search: async ({ commit }, { search, page, sort }) => {
      commit(mutationTypes.SET_UI_FLAG, { fetchingList: true });
      try {
        const {
          data: { payload, meta },
        } = await CompanyAPI.search(search, page, sort);
        commit(mutationTypes.SET, payload);
        commit(mutationTypes.SET_META, meta);
      } catch (error) {
        // Error
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { fetchingList: false });
      }
    },
    fetchIndustries: async ({ commit }) => {
      try {
        const { data } = await CompanyAPI.getIndustries();
        commit('SET_INDUSTRIES', data.industries);
      } catch (error) {
        // Error
      }
    },
    fetchCompanyDeals: async ({ commit }, { companyId, params = {} }) => {
      commit(mutationTypes.SET_UI_FLAG, { fetching: true });
      try {
        const { data } = await CompanyAPI.getDeals(companyId, params);
        commit('SET_COMPANY_DEALS', {
          companyId,
          data: camelcaseKeys(data, { deep: true }),
        });
      } catch (error) {
        // Error
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { fetching: false });
      }
    },
    fetchCompanyContacts: async ({ commit }, { companyId, params = {} }) => {
      commit(mutationTypes.SET_UI_FLAG, { fetching: true });
      try {
        const { data } = await CompanyAPI.getContacts(companyId, params);
        commit('SET_COMPANY_CONTACTS', {
          companyId,
          data: camelcaseKeys(data, { deep: true }),
        });
      } catch (error) {
        // Error
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { fetching: false });
      }
    },
  }),
});
